module.exports = __webpack_public_path__ + "img/8cbc9518b0cc4b5e99a4194b1bb7c0d0-1024.6f677395.jpg";